import React from 'react';
import { motion } from 'framer-motion';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, ButtonBase } from '@mui/material';
import { colors, motion as m } from '../brand/tokens';

function NavBar({ items }) {
  const { pathname } = useLocation();

  return (
    <Box
      component="nav"
      aria-label="Main"
      sx={{
        position: 'fixed',
        top: 'calc(var(--safe-top) + 12px)',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1100,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          p: '4px',
          borderRadius: 999,
          background: 'rgba(255, 255, 255, 0.78)',
          backdropFilter: 'saturate(180%) blur(16px)',
          WebkitBackdropFilter: 'saturate(180%) blur(16px)',
          boxShadow: '0 6px 24px -8px rgba(30, 20, 17, 0.25)',
          border: '1px solid rgba(255, 255, 255, 0.6)',
        }}
      >
        {items.map(({ name, url, icon: Icon }) => {
          const isActive = pathname === url;
          return (
            <ButtonBase
              key={url}
              component={RouterLink}
              to={url}
              aria-current={isActive ? 'page' : undefined}
              sx={{
                position: 'relative',
                gap: 1,
                height: 44,
                px: { xs: 2.25, sm: 3 },
                borderRadius: 999,
                fontSize: 15,
                fontWeight: 600,
                color: isActive ? colors.orange : 'rgba(30, 20, 17, 0.62)',
                transition: 'color 0.2s',
                '&:hover': { color: colors.orange },
                '&.Mui-focusVisible': { outline: `2px solid ${colors.orange}`, outlineOffset: 2 },
              }}
            >
              {isActive && (
                <motion.span
                  layoutId="nav-bubble"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 999,
                    backgroundColor: 'rgba(230, 90, 47, 0.12)',
                  }}
                  transition={m.spring.gentle}
                />
              )}
              <Icon size={18} aria-hidden="true" style={{ position: 'relative' }} />
              <span style={{ position: 'relative' }}>{name}</span>
            </ButtonBase>
          );
        })}
      </Box>
    </Box>
  );
}

export default NavBar;
